import { useQuery } from '@tanstack/react-query';
import { useCallback } from 'react';
import { countryQuery, useAxiosCmsInstance } from '@gov-nx/api';
import { useCmsUrlPath, useListsStore } from '@gov-nx/store';

export interface CountryLoaderProps {
	onSuccess?: () => void;
	onError?: (e: Error) => void;
}

export const useCountryLoader = (props?: CountryLoaderProps) => {
	const saveCountryList = useListsStore('saveCountryList');
	// eslint-disable-next-line react-hooks/exhaustive-deps -- These dependencies are correct
	const countries = useListsStore('countries') ?? [];
	const { baseCmsUrlPath } = useCmsUrlPath();
	const { axiosCmsInstance } = useAxiosCmsInstance();

	const query = useQuery({
		queryKey: ['countries'],
		queryFn: () => countryQuery(axiosCmsInstance, baseCmsUrlPath as string),
		retry: 1,
		enabled: false,
		refetchOnWindowFocus: false,
		onError: (e) => {
			if (props && props.onError) {
				props.onError(e as Error);
			}
		},
		onSuccess: (data) => {
			saveCountryList(data);
			if (props && props.onSuccess) {
				props.onSuccess();
			}
		},
	});

	const loadCountries = useCallback(async (): Promise<void> => {
		if (Array.isArray(countries) && countries.length) {
			return Promise.resolve();
		}
		await query.refetch();
	}, [countries, query]);

	return { loadCountries };
};
